import React, { Component } from 'react';
import convert from 'convert-units';
import Loadable from './loading/Loadable.js';

// The base unit is cm

import api from '../../api/index.js';

class Distance extends Component {
	constructor(props) {
		super(props);
		this.state = {
			units: false
		}
	}
	
	async refresh() {
		this.setState({units: await api.settings.get('display_units')});
	}
	
	componentDidMount() {
		this.refresh();
	}
	
	render() {
		let val = '';
		if (this.state.units !== false) {
			console.log(this.props.value);
			val = convert(parseFloat(this.props.value)).from('cm').to(this.state.units);
			const precision = this.props.precision || 2;
			const mult = Math.pow(10,precision);
			val = Math.round(val*mult)/mult;
		}
		return (
			<Loadable ready={this.state.units !== false}>
				{val} {this.state.units}
			</Loadable>
		);
	}
}

export default Distance;
